export default {
    dependencies: ['trackingservice'],
    callable(trackingService) {
        const url = new URL(document.baseURI);
        const adId = url.searchParams.get('finnkode');
        const events = [];
        if (!adId) {
            return;
        }
        if (!url.searchParams.get('s')) {
            events.push({
                ecType: 'AD',
                ecCategory: 'NoOfPageViews_Main',
                context: {
                    finnkode: adId,
                },
            });
        }
        if (url.searchParams.get('ecid')) {
            events.push({
                ecType: 'AD',
                ecCategory: url.searchParams.get('ecid'),
                context: {
                    finnkode: adId,
                },
            });
        }
        events.forEach(e => {
            trackingService.trackEventObject(e);
        });

        const counterId = url.searchParams.get('webstatClickId');
        if (counterId) {
            trackingService.deprecatedTrackEvent(counterId);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/trackAd.js